import store from '../../store';
import Errors from '../../Errors';
import ProductRating from '../ProductRating.vue';
import ProductCardMixin from '../../mixins/ProductCardMixin';
import RelatedProducts from './show/RelatedProducts.vue';

export default {
    components: { ProductRating, RelatedProducts },

    mixins: [
        ProductCardMixin,
    ],

    props: ['product', 'reviewCount', 'avgRating'],

    data() {
        return {
            price: this.product.formatted_price,
            activeTab: 'description',
            currentReviewPage: 1,
            fetchingReviews: false,
            reviews: {},
            addingNewReview: false,
            reviewForm: {},
            cartItemForm: {
                product_id: this.product.id,
                qty: 1,
                options: {},
            },
            errors: new Errors(),
        };
    },

    computed: {
        totalReviews() {
            if (! this.reviews.total) {
                return this.reviewCount;
            }

            return this.reviews.total;
        },

        ratingPercent() {
            return (this.avgRating / 5) * 100;
        },

        emptyReviews() {
            return this.totalReviews === 0;
        },

        totalReviewPage() {
            return Math.ceil(this.reviews.total / 4);
        },
    },

    created() {
        window.onscroll =  () => {
            if(this.isNotInView($('.number-picker'))) {
                $('.btn-add-to-cart').addClass('float-add-to-cart');
            } else {
                $('.btn-add-to-cart').removeClass('float-add-to-cart');
            }
        }
        this.fetchReviews();
    },

    mounted() {
        $(this.$refs.upSellProducts).slick({
            rows: 0,
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            rtl: window.FleetCart.rtl,
        });

        if($('#list-option-values-0').length > 0){
            $('#list-option-values-0 li:first').click();
        }
    },

    methods: {
        updateQuantity(qty) {
            if (qty < 1 || this.exceedsMaxStock(qty)) {
                return;
            }

            if (isNaN(qty)) {
                qty = 1;
            }

            this.cartItemForm.qty = qty;
        },

        exceedsMaxStock(qty) {
            return this.product.manage_stock && this.product.qty < qty;
        },

        changeReviewPage(page) {
            this.currentReviewPage = page;

            this.fetchReviews();
        },

        updatePrice() {
            this.$nextTick(() => {
                $.ajax({
                    method: 'POST',
                    url: route('products.price.show', { id: this.product.id }),
                    data: { options: this.cartItemForm.options },
                }).then((res) => {
                    if(res.combination_id){
                        setTimeout($('img[data-combination="'+res.combination_id+'"]').click(), 3000)
                    }
                    this.price = res.price;
                }).catch((xhr) => {
                    this.$notify(xhr.responseJSON.message);
                });
            });
        },

        updateSecondOptionValues(optionId, valueId) {
            this.$nextTick(() => {
                $.ajax({
                    method: 'POST',
                    url: route('products.availableSecondOptionValues', { product_id: this.product.id, first_option_id: optionId, first_option_value_id: valueId }),
                    data: { },
                }).then((dataJson) => {
                    $('#list-option-values-1 li').hide();
                    dataJson.optionValues.forEach(function (val, index) {
                        $('#li-option-value-'+val).show();
                    });

                    $('#list-option-values-1 li:visible').first().click();

                }).catch((xhr) => {
                    this.$notify(xhr.responseJSON.message);
                });
            });
        },

        optionValueIsActive(optionId, valueId, optionLevel) {
            if (! this.cartItemForm.options.hasOwnProperty(optionId)) {
                return false;
            }

            return this.cartItemForm.options[optionId] === valueId;
        },

        changeOptionValue(optionId, valueId, optionLevel, optionsCount) {
            if (this.optionValueIsActive(optionId, valueId)) {
                //this.$delete(this.cartItemForm.options, optionId);
            } else {
                this.$set(this.cartItemForm.options, optionLevel, valueId);
                this.errors.clear(`options.${optionId}`);
            }
            if(optionLevel == 0 && optionsCount > 1){
                //alert('call update second option values');
                this.updateSecondOptionValues(optionId, valueId);
            }
            else{
                //alert('call update price');
                this.updatePrice();
            }
        },

        fetchReviews() {
            this.fetchingReviews = true;

            $.ajax({
                method: 'GET',
                url: route('products.reviews.index', {
                    productId: this.product.id,
                    page: this.currentReviewPage,
                }),
            }).then((reviews) => {
                this.reviews = reviews;
            }).catch((xhr) => {
                this.$notify(xhr.responseJSON.message);
            }).always(() => {
                this.fetchingReviews = false;
            });
        },

        addNewReview() {
            this.addingNewReview = true;

            $.ajax({
                method: 'POST',
                url: route('products.reviews.store', { productId: this.product.id }),
                data: this.reviewForm,
            }).then((review) => {
                this.reviewForm = {};
                this.reviews.total++;
                this.reviews.data.unshift(review);

                $('.captcha-input').prev('img').trigger('click');
            }).catch((xhr) => {
                if (xhr.status === 422) {
                    this.errors.record(xhr.responseJSON.errors);
                } else {
                    this.$notify(xhr.responseJSON.message);
                }
            }).always(() => {
                this.addingNewReview = false;
            });
        },

        addToCart() {
            this.addingToCart = true;

            $.ajax({
                method: 'POST',
                url: route('cart.items.store', this.cartItemForm),
            }).then((cart) => {
                console.log(cart)
                store.updateCart(cart);

                $('.header-cart').trigger('click');
            }).catch((xhr) => {
                if (xhr.status === 422) {
                    this.errors.record(xhr.responseJSON.errors);
                } else {
                    this.$notify(xhr.responseJSON.message);
                }
            }).always(() => {
                this.addingToCart = false;
            });
        },

        isNotInView(elem) {
            return $(elem).offset().top - $(window).scrollTop() < $(elem).height() ;
        },
    },
};
